import { setStartDate, setEndDate } from '@/components/common/common_js'

// 转译数据
export const translateData = (data, startDate, endDate) => {
  const tempStartDate = setStartDate(startDate)
  const tempEndDate = setEndDate(endDate)

  let clientData = []
  let tempTotalClientNew = 0

  // 筛选符合条件的客户
  for (const item of data) {
    const tempDate = new Date(item.createdAt)
    const tempIsComplete = item.isComplete === 1
    const tempClientData = {
      ...item,
      select: tempIsComplete && tempStartDate && tempEndDate && tempDate >= new Date(tempStartDate).getTime() && tempDate <= new Date(tempEndDate).getTime(),
      stages: []
    }

    clientData.push(tempClientData)

    if (tempIsComplete && tempClientData.select) tempTotalClientNew++
  }

  clientData = clientData.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

  return {
    sessionInquire: clientData,
    totalInquireNew: tempTotalClientNew
  }
}

// 获取客户阶段数据的状态
export const getStagusVal = function (status) {
  let data = ''
  let tag = ''

  switch (status) {
    case 0:
      data = '进行中'
      tag = 'planning'
      break
    case 1:
      data = '已完成'
      tag = 'success'
      break
    default:
      data = '进行中'
      tag = 'planning'
      break
  }

  return {
    status: data,
    tag: tag
  }
}



// WEBPACK FOOTER //
// ./src/components/page-client/index-inquire.js